module.exports = __webpack_public_path__ + "img/cover-si-les-os-s-animent.3c4f8b50.jpg";